import api from '@/utils/api'
const state = {
	contractProfile: {
		all: '',//合同总数
		finishedCount: '',//完成数量
		inProgressCount: '',//签署中数量
		nearDeadlineCount: '',//即将到期数量
		refusedCount: '',//拒签数量
		unarchivedCount: '',//未归档数量
		unprotectedCount: '',//未保障数量
		protectedCount: '',//保障中数量
		expiredCount: '',//已到期数量
		insuranceInProcessCount: '',//拒签数量
		terminatedCount: '',//已完结数量
	}
}
const mutations = {
	setContractProfile(state, payload) {
		state.contractProfile = {
			...state.contractProfile,
			...payload
		}
	}
}
const actions = {
	async getContractProfile({ commit, state }) {     //合同统计
		const { status, data } = await api.getContractProfile()
		if (status === 200) {
			commit('setContractProfile', data);
		}
	},
}
export default {
	namespaced: true,
	state,
	mutations,
	actions
}